"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var BlurDiv_1 = __importDefault(require("atomicComponents/atoms/Div/BlurDiv"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var hooks_2 = require("containers/SaaSAudit/hooks");
var selectors_1 = require("containers/SaaSAudit/selectors");
var AuditCallout_1 = __importDefault(require("../Report/components/AuditCallout"));
var SaaSAnalysedFooter_1 = __importDefault(require("./SaaSAnalysedFooter"));
var SaaSAnalysedHeader_1 = __importDefault(require("./SaaSAnalysedHeader"));
var SaaSAnalysedRow_1 = __importDefault(require("./SaaSAnalysedRow"));
var SaaSAnalysedSearchAndFilter_1 = __importDefault(require("./SaaSAnalysedSearchAndFilter"));
var utils_1 = require("./utils");
var SaaSAnalysed = function () {
    var isBlocked = (0, react_redux_1.useSelector)(selectors_1.selectBlockSaasAuditParts);
    var servicesStats = (0, react_redux_1.useSelector)(selectors_1.selectSlightlyPopulatedServiceStatsWithToolAnalysis);
    var sortedSStats = (0, hooks_1.useSortArray)(servicesStats, utils_1.FieldProcessors);
    var _a = __read((0, hooks_2.useFilterAnalyzedTools)(sortedSStats || []), 3), filteredServicesStats = _a[0], searchProps = _a[1], filterProps = _a[2];
    var totalMissedOpportunities = (0, sumBy_1.default)(filteredServicesStats, 'toolAnalysis.missedOpportunityAmount') || 0;
    var totalAnnualSpend = (0, sumBy_1.default)(filteredServicesStats, 'toolAnalysis.last12MonthSpend') || 0;
    var totalActiveAnnualSpend = (0, sumBy_1.default)(filteredServicesStats, 'toolAnalysis.activeAnnualSpend') || 0;
    if (!(0, react_redux_firebase_1.isLoaded)(filteredServicesStats)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - SaaS Analysed", description: "SaaS Analysed" }), (0, jsx_runtime_1.jsx)(AuditCallout_1.default, {}), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ overflow: "hidden", pb: 3, pt: 0.5 }, { children: [isBlocked && (0, jsx_runtime_1.jsx)(BlurDiv_1.default, {}), (0, jsx_runtime_1.jsx)(SaaSAnalysedSearchAndFilter_1.default, { serviceStats: sortedSStats, searchProps: searchProps, filterProps: filterProps }), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1080 }, { children: [(0, jsx_runtime_1.jsx)(SaaSAnalysedHeader_1.default, { toolsCount: filteredServicesStats === null || filteredServicesStats === void 0 ? void 0 : filteredServicesStats.length }), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: filteredServicesStats === null || filteredServicesStats === void 0 ? void 0 : filteredServicesStats.map(function (sStat) { return ((0, jsx_runtime_1.jsx)(SaaSAnalysedRow_1.default, { serviceStat: sStat }, sStat.id)); }) }), (0, jsx_runtime_1.jsx)(SaaSAnalysedFooter_1.default, { toolsCount: filteredServicesStats === null || filteredServicesStats === void 0 ? void 0 : filteredServicesStats.length, totalMissed: totalMissedOpportunities, totalSpend: totalAnnualSpend, totalAnnualised: totalActiveAnnualSpend })] }))] }))] }));
};
exports.default = (0, SortHoC_1.default)(SaaSAnalysed, { key: 'serviceName', order: 1 });
